import { reactive } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { DomainItem } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import { getCustomDomainOrWebUrl } from '@/renderer/scripts/utils/CustomDomain/customDomain';

type SelectedList = SMH.SpaceFileItemData | SMH.FavoriteFileItemData;
type DialogVisibleType = 'showForm' | 'showResult' | 'showInfo';
interface Handler {
  fileCollectDialog: {
    showForm: boolean;
    showResult: boolean;
    showInfo: boolean;
    code: string;
    domain: string;
    joinType: number;
    folderInfo: {};
  };
  fileColleDialogMethods: {
    openFileCollectFormDialog: (
      selectedList: SelectedList[],
      opts?: {
        spaceId: string;
      },
    ) => void;
    closeFileCollectResultDialog: () => void;
    onSaveFileCollectForm: (res: { code: string; joinType: number; domains: DomainItem[] }) => void;
    toggleDialogVisible: (type: DialogVisibleType, show: boolean) => void;
  };
}
const fileCollectDialogHandler = (): Handler => {
  const fileCollectDialog = reactive({
    showForm: false,
    showResult: false,
    showInfo: false,
    folderInfo: {},
    code: '',
    domain: '',
    joinType: 0,
  });
  const fileColleDialogMethods = {
    openFileCollectFormDialog(
      selectedList: SelectedList[],
      opts = {
        spaceId: '',
      },
    ) {
      if (selectedList.length === 0) return tips.error(i18n_t('请选择文件或文件夹'));
      const { spaceId } = selectedList[0];
      fileCollectDialog.showForm = true;
      Object.assign(fileCollectDialog.folderInfo, {
        ...selectedList[0],
        spaceId: spaceId || opts.spaceId,
      });
    },
    closeFileCollectResultDialog() {
      fileCollectDialog.showResult = false;
    },
    onSaveFileCollectForm(res: { code: string; joinType: number; domains: DomainItem[] }) {
      const { code, joinType, domains } = res;
      const domain = getCustomDomainOrWebUrl(domains);
      Object.assign(fileCollectDialog, { code, joinType, domain, showResult: true });
    },
    toggleDialogVisible(type: DialogVisibleType, show: boolean) {
      fileCollectDialog[type] = show;
    },
  };
  return {
    fileCollectDialog,
    fileColleDialogMethods,
  };
};
export default fileCollectDialogHandler;
